import { render, staticRenderFns } from "./WorkflowsPage.vue?vue&type=template&id=4f58c697&scoped=true"
import script from "./WorkflowsPage.vue?vue&type=script&lang=js"
export * from "./WorkflowsPage.vue?vue&type=script&lang=js"
import style0 from "./WorkflowsPage.vue?vue&type=style&index=0&id=4f58c697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f58c697",
  null
  
)

export default component.exports